import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Menu, MenuItem, Tab, Tabs } from "@mui/material";
import { getUserByUserId, getFollowers } from "apis/UserServiceApi";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { RootState, AppDispatch  } from "store/types";
import { useDispatch } from "react-redux";
import { toggleIdol } from "store/idol/idol.slice";
import Loader from "components/common/Loader";
import {
  BackdropContainer,
  BackdropPicture,
  ButtonsWrapper,
  Description,
  DescriptionContainer,
  FollowButton,
  FollowingButton,
  HeaderContainer,
  InnerHeader,
  Miscellaneous,
  ProfilePicture,
  TabBarContainer,
  TabsAndButtonsWrapper,
  TabsWrapper,
  Username,
} from "./OrgBannerInfo.styles";

/* Pestañas a mostrar en la barra */
const ALL_TABS = [
  { value: "home", label: "Home", disabled: false },
  // { value: "about", label: "About", disabled: true },
  { value: "events", label: "Events", disabled: false },
  { value: "projects", label: "Projects", disabled: false },
  // { value: "programs", label: "Programs", disabled: false },
];

/** Utilidad para comparar rápidamente arrays de { value } */
function shallowEqualArrays<T extends { value: string }>(arr1: T[], arr2: T[]) {
  if (arr1.length !== arr2.length) return false;
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i].value !== arr2[i].value) {
      return false;
    }
  }
  return true;
}

function OrgBannerInfo() {
  const publicUserId = Number(useParams().publicUserId);
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = publicUserId
    ? location.pathname.split("/")[3]
    : location.pathname.split("/")[2];
  const [name, setName] = useState("Loading...");
  const [description, setDescription] = useState("Loading...");
  const [profileUrl, setProfileUrl] = useState("");
  const [followers, setFollowers] = useState(0);
  const [backdrop, setBackdrop] = useState("");
  const [industry, setIndustry] = useState("");
  const [myselfType, setMyselfType] = useState("");
  const [locationCity, setLocationCity] = useState("");
  const [locationCountry, setLocationCountry] = useState("");
  const [userTypeLocal, setUserType] = useState("");
  const [isIdolized, setIsIdolized] = useState(false);

  const [moreAnchorEl, setMoreAnchorEl] = useState<null | HTMLElement>(null);
  const isMoreMenuOpen = Boolean(moreAnchorEl);

  const handleOpenMoreMenu = (event: React.MouseEvent<HTMLElement>) => {
    setMoreAnchorEl(event.currentTarget);
  };
  const handleCloseMoreMenu = () => {
    setMoreAnchorEl(null);
  };
  const userType = useSelector(
    (state: RootState) => state.user.user_type
  );
  const idols = useSelector((state: RootState) => state.idol.idols);
  const togglingIds = useSelector((state: RootState) => state.idol.togglingIds);
  const [visibleTabs, setVisibleTabs] = useState<typeof ALL_TABS>([]);
  const [hiddenTabs, setHiddenTabs] = useState<typeof ALL_TABS>([]);
  const containerRef = useRef<HTMLDivElement>(null);
  const tabsWrapperRef = useRef<HTMLDivElement>(null);
  const buttonsWrapperRef = useRef<HTMLDivElement>(null);
  const [tabWidths, setTabWidths] = useState<Record<string, number>>({});
  const moreTabKey = "__MORE__";
  const userId = useSelector((state: RootState) => state.user.id);
  const userName = useSelector((state: RootState) => state.user.name);
  const userDescription = useSelector(
    (state: RootState) => state.user.bio_description
  );
  const userProfileUrl = useSelector(
    (state: RootState) => state.user.socialAvatarUrl
  );
  const userBackdrop = useSelector(
    (state: RootState) => state.user.banner_image_url
  );
  const userIndustry = useSelector(
    (state: RootState) => state.user.templateModel.industry
  );
  const userMyselfType = useSelector(
    (state: RootState) => state.user.templateModel.myself_type
  );
  const userLocationCity = useSelector((state: RootState) =>
    state.user.location ? state.user.location[0] : ""
  );
  const userLocationCountry = useSelector((state: RootState) =>
    state.user.location ? state.user.location[1] : ""
  );

  const dispatch = useDispatch<AppDispatch>();

  const handleToggleIdol = () => {
    if (togglingIds.includes(publicUserId)) return;

    dispatch(toggleIdol(publicUserId))
      .unwrap()
      .then((res) => {
        setIsIdolized(res.isIdolized);
        setFollowers(res.followersCount);
      })
      .catch((err) => {
        console.error("Error toggling idol:", err);
      });
  };

  useEffect(() => {
    const filtered = ALL_TABS.filter((tab) => {
      if (tab.value === "projects" && userTypeLocal !== "organization") {
        return false;
      }
      return true;
    });
    setVisibleTabs(filtered);
  }, [publicUserId, userTypeLocal]);

  useEffect(() => {
    if (publicUserId) {
      getUserByUserId(publicUserId).then((res) => {
        setName(res.name);
        setDescription(res.bio_description || "No description available");
        setProfileUrl(res.socialAvatarUrl || "default-profile-url");
        setBackdrop(res.banner_image_url || "");
        setIndustry(res.templateModel.industry);
        setMyselfType(res.templateModel.myself_type);
        setLocationCity(res.location ? res.location[0] : "");
        setLocationCountry(res.location ? res.location[1] : "");
        setUserType(res.user_type);
      });
    } else {
      setName(userName);
      setDescription(userDescription || "No description available");
      setProfileUrl(userProfileUrl || "default-profile-url");
      setBackdrop(userBackdrop || "");
      setIndustry(userIndustry || "");
      setMyselfType(userMyselfType || "");
      setLocationCity(userLocationCity || "");
      setLocationCountry(userLocationCountry || "");
      setUserType(userType || "");
    }
    if (publicUserId) {
      getFollowers(publicUserId)
        .then((res) => {
          setFollowers(res.followersCount);
          setIsIdolized(res.isIdolized); 
        })
        .catch((error) => {
          console.error("Error fetching public profile:", error);
        });
    } else if (userId) {
      getFollowers(userId)
        .then((res) => {
          setFollowers(res.followersCount);
        })
        .catch((error) => {
          console.error("Error fetching public profile:", error);
        });
    }
  }, [publicUserId, userId, userName, userDescription, userProfileUrl]);

  useEffect(() => {
    const pathParts = location.pathname.split("/");

    const isOrgProfile = pathParts[1] === "profile";
    const viewedUserId = Number(pathParts[2]);

    if (isOrgProfile && viewedUserId === userId) {
      const section = pathParts[3] || "home";
      navigate(`/org/${section}`, { replace: true });
    }
  }, [location.pathname, userId]);

  const handleChangeTab = (
    event: React.SyntheticEvent | null,
    newTab: string
  ) => {
    if (newTab === "__MORE__") {
      event?.preventDefault();
      handleOpenMoreMenu(event as React.MouseEvent<HTMLElement>);
    } else {
      navigate(
        `/${
          publicUserId ? "profile/" + publicUserId : "org"
        }/${newTab.toLowerCase()}`
      );
    }
  };

  useEffect(() => {
    const onResize = () => handleResize();
    window.addEventListener("resize", onResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, [tabWidths]);

  function handleResize() {
    if (!containerRef.current || !buttonsWrapperRef.current) return;

    const containerWidth = containerRef.current.offsetWidth;
    const buttonsWidth = buttonsWrapperRef.current.offsetWidth || 0;
    const spaceForTabs = containerWidth - buttonsWidth - 20; // Margen de seguridad

    const moreWidth = tabWidths[moreTabKey] || 60;

    const calcTotal = (list: typeof ALL_TABS) =>
      list.reduce((acc, x) => acc + (tabWidths[x.value] || 60), 0);

    let newVisible = [...visibleTabs];
    let newHidden: typeof ALL_TABS = [];

    let totalWidth = calcTotal(newVisible);

    if (totalWidth > spaceForTabs) {
      totalWidth += moreWidth;
      while (newVisible.length && totalWidth > spaceForTabs) {
        const popped = newVisible.pop()!;
        newHidden.unshift(popped);
        totalWidth = calcTotal(newVisible) + moreWidth;
      }
    }
    if (
      !shallowEqualArrays(newVisible, visibleTabs) ||
      !shallowEqualArrays(newHidden, hiddenTabs)
    ) {
      setVisibleTabs(newVisible);
      setHiddenTabs(newHidden);
    }
  }

  const measureTabRef = (value: string, el: HTMLDivElement | null) => {
    if (!el) return;
    const w = el.offsetWidth;
    setTabWidths((prev) => {
      if (prev[value] === w) return prev;
      return { ...prev, [value]: w };
    });
  };

  const renderTabs = () => {
    const mainTabs = visibleTabs.map((t) => (
      <Tab
        key={t.value}
        value={t.value}
        label={<span style={{ color: "#FE2F67" }}>{t.label}</span>}
        style={{ minWidth: "80px", textTransform: "none" }}
        disabled={t.disabled}
      />
    ));
    if (hiddenTabs.length > 0) {
      mainTabs.push(
        <Tab
          key="__MORE__"
          value="__MORE__"
          style={{ minWidth: "80px", textTransform: "none" }}
          label={
            <span
              style={{
                color: "#FE2F67",
                display: "flex",
                alignItems: "center",
              }}
            >
              More <KeyboardArrowDownIcon style={{ marginLeft: "5px" }} />
            </span>
          }
        />
      );
    }
    return mainTabs;
  };
    const isLoading = togglingIds.includes(publicUserId);
  return (
    <div style={{ padding: "3% 4% 0 4%" }}>
      {/* Banner */}
      <HeaderContainer>
        <BackdropContainer>
          <BackdropPicture src={backdrop || "default-backdrop-url"} />
        </BackdropContainer>
        <InnerHeader>
          <ProfilePicture src={profileUrl || "default-profile-url"} />
          <DescriptionContainer>
            <Username>{name}</Username>
            <Description>{description}</Description>
            <Miscellaneous>
              {industry || myselfType} · {locationCity}, {locationCountry} ·{" "}
              {followers} Followers
            </Miscellaneous>
          </DescriptionContainer>
        </InnerHeader>
      </HeaderContainer>
      <TabBarContainer ref={containerRef}>
        <TabsAndButtonsWrapper>
          {/* Tabs */}
          <TabsWrapper ref={tabsWrapperRef}>
            <Tabs
              value={currentPath || "home"}
              onChange={handleChangeTab}
              variant="standard"
              TabIndicatorProps={{
                sx: { backgroundColor: "#FE2F67", height: 2 },
              }}
            >
              {renderTabs()}
            </Tabs>
          </TabsWrapper>
          {!Number.isNaN(publicUserId) && publicUserId !== userId &&  (
            <ButtonsWrapper ref={buttonsWrapperRef}>
              {/* <JoinCommunityButton>
              Join Community{" "}
              <KeyboardArrowDownIcon style={{ marginLeft: "3px" }} />
              </JoinCommunityButton> */}
              {isIdolized ? (
                <FollowingButton onClick={handleToggleIdol} disabled={isLoading}>
                  {isLoading ? (
                    <Loader size={15}/>
                  ) : (
                    "Following"
                  )}
                </FollowingButton>
              ) : (
                <FollowButton onClick={handleToggleIdol} disabled={isLoading}>
                  {isLoading ? (
                    <Loader size={15} color = 'e0e0e0'/>
                  ) : (
                    "Follow"
                  )}
                </FollowButton>
              )}
            </ButtonsWrapper>
          )}
        </TabsAndButtonsWrapper>
      </TabBarContainer>
      {/* Menu "More" con los tabs escondidos */}
      <Menu
        anchorEl={moreAnchorEl}
        open={isMoreMenuOpen}
        onClose={handleCloseMoreMenu}
        keepMounted
      >
        {hiddenTabs.map((t) => (
          <MenuItem
            key={"hidden_" + t.value}
            onClick={() => {
              handleChangeTab(null, t.value);
              handleCloseMoreMenu();
            }}
            disabled={t.disabled}
          >
            {t.label}
          </MenuItem>
        ))}
      </Menu>
      <div style={{ visibility: "hidden", position: "absolute", left: -9999 }}>
        {visibleTabs.map((t) => (
          <div
            key={"measure_" + t.value}
            ref={(el) => measureTabRef(t.value, el)}
            style={{
              display: "inline-block",
              padding: "6px 12px",
              fontFamily: "Roboto",
              fontSize: "14px",
              whiteSpace: "nowrap",
            }}
          >
            {t.label}
          </div>
        ))}
        {/* Mide ancho del tab "More" */}
        <div
          key={"measure_more"}
          ref={(el) => measureTabRef(moreTabKey, el)}
          style={{
            display: "inline-block",
            padding: "6px 12px",
            fontFamily: "Roboto",
            fontSize: "14px",
            whiteSpace: "nowrap",
          }}
        >
          More <KeyboardArrowDownIcon style={{ fontSize: "14px" }} />
        </div>
      </div>
    </div>
  );
}

export default OrgBannerInfo;
